import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { useFlag } from 'utils/launchdarkly';

export default function useStaticIdentifier() {
  const { loyaltyUser, loyaltyUserId } = useLoyaltyUser();
  const isStaticIdentifierEnabled = Boolean(useFlag('enable-static-in-store-identification'));
  const enableLoyaltyAlohaIntegration = useFlag('enable-loyalty-aloha-integration');
  const legacyLoyaltyIdMetadata = loyaltyUser?.metadata?.find(
    metadata => metadata?.key === 'legacyLoyaltyId'
  );
  const loyaltyQRCodeId = loyaltyUser?.metadata?.find(
    metadata => metadata?.key === 'loyaltyQRCodeId'
  )?.value;
  let staticIdentifier;
  if (enableLoyaltyAlohaIntegration) {
    staticIdentifier = legacyLoyaltyIdMetadata?.value || null;
  } else if (loyaltyQRCodeId) {
    staticIdentifier = loyaltyQRCodeId;
  } else {
    // The static identifier is the loyalty id but this can be changed depending on biz requirements
    staticIdentifier = isStaticIdentifierEnabled && loyaltyUserId ? loyaltyUserId : null;
  }
  return { staticIdentifier, isStaticIdentifierEnabled };
}
